import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getTopCountries } from '../analytics.service';
import { FiveMinutes, InitialRetryDelay } from '../constants';
export const useTopCountries = ({ subdomain = getSubdomain(), startDate, endDate, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        staleTime: FiveMinutes,
        ...options,
        queryKey: analyticsKeys.topCountries(subdomain, startDate, endDate),
        queryFn: () => getTopCountries(subdomain, startDate, endDate),
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
